import { useState, useEffect } from "react";
import { apiFetch } from "../../lib/config";

interface ErrorGroup {
  id: string;
  service_name: string;
  fingerprint: string;
  title: string;
  first_seen: string;
  last_seen: string;
  occurrence_count: number;
}

export function ErrorsPage() {
  const [groups, setGroups] = useState<ErrorGroup[]>([]);
  const [service, setService] = useState("");
  const [loading, setLoading] = useState(false);

  async function loadErrors() {
    setLoading(true);
    const params = new URLSearchParams();
    if (service) params.set("service", service);
    const r = await apiFetch(`/api/v1/telemetry/errors/?${params.toString()}`);
    if (r.ok) setGroups(await r.json());
    setLoading(false);
  }

  useEffect(() => { loadErrors(); }, []);

  function handleSearch(e: React.FormEvent) {
    e.preventDefault();
    loadErrors();
  }

  return (
    <div className="ac-page">
      <div className="ac-page-header">
        <div className="ac-page-header__left">
          <h1 className="ac-page-title">Error Groups</h1>
          <p className="ac-page-subtitle">Grouped error fingerprints across platform services</p>
        </div>
      </div>

      <form className="ac-filter-bar" onSubmit={handleSearch}>
        <input
          type="text"
          className="aptean-input"
          placeholder="Filter by service..."
          value={service}
          onChange={(e) => setService(e.target.value)}
          aria-label="Service filter"
          style={{ minWidth: 200 }}
        />
        <button type="submit" className="aptean-btn aptean-btn--primary" disabled={loading}>Search</button>
        <span className="ac-filter-bar__sep" />
        {!loading && <span style={{ fontSize: "0.8125rem", color: "var(--aptean-text-secondary)" }}>{groups.length} group{groups.length !== 1 ? "s" : ""}</span>}
      </form>

      <div className="ac-table-wrap">
        <table className="ac-table">
          <thead>
            <tr>
              <th style={{ width: "40%" }}>Error Title</th>
              <th>Service</th>
              <th>First Seen</th>
              <th>Last Seen</th>
              <th className="ac-th--right">Occurrences</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5}><div className="ac-empty"><div className="ac-empty__body">Loading error groups...</div></div></td></tr>
            ) : groups.length === 0 ? (
              <tr><td colSpan={5}><div className="ac-empty"><div className="ac-empty__icon">&#10003;</div><div className="ac-empty__title">No error groups found</div><div className="ac-empty__body">No errors matching the current filter.</div></div></td></tr>
            ) : groups.map((g) => (
              <tr key={g.id}>
                <td>
                  <div className="ac-row-title">{g.title}</div>
                  <div className="ac-row-sub" style={{ fontFamily: "var(--aptean-font-mono)" }}>{g.fingerprint}</div>
                </td>
                <td className="ac-td--muted">{g.service_name}</td>
                <td className="ac-td--muted">{new Date(g.first_seen).toLocaleString()}</td>
                <td className="ac-td--muted">{new Date(g.last_seen).toLocaleString()}</td>
                <td className="ac-td--right">
                  <span className="ac-badge ac-badge--error">{g.occurrence_count}x</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
